import React, { useContext, useState } from 'react';
import { RestaurantsContext, IRestaurantsContext } from '../../../../../restaurantsState/restaurantsContext';
import { UserRoles, IItemRestaurant } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import moment from 'moment';
import Text from 'components/Text/Text';
import DataController from 'components/DataController/DataController';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemRestaurant;
	index: number;
}

export const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForRestoring, setIDForDeletion } = useContext<IRestaurantsContext>(RestaurantsContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const hasRestoreAccess = useRoleAccess([UserRoles.SUPER_USER]);
	const hasDeleteAccess = useRoleAccess([UserRoles.SUPER_USER]);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const nameRowClasses = classNames(style.row, style.name);
	const customerRowClasses = classNames(style.row, style.customer);
	const cityRowClasses = classNames(style.row, style.city);
	const countryRowClasses = classNames(style.row, style.country);
	const archivingDateClasses = classNames(style.row, style.archivingDate);
	const userClasses = classNames(style.row, style.user);
	const actionRowClasses = classNames(style.row, style.action);

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForRestoring = () => {
		setIDForRestoring(data.id);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={nameRowClasses}>
					<Text className={style.customerName} translationKey={data.name} withTooltip={true} />
					<ChunkOfTextWithCopying text={data.id} className={style.copyId} />
				</div>
				<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
				<Text className={cityRowClasses} translationKey={data.city.name} withTooltip={true} />
				<Text className={countryRowClasses} translationKey={data.country.name} withTooltip={true} />
				<Text
					className={archivingDateClasses}
					translationKey={data.archivedDate ? moment(data.archivedDate).format('MM/DD/YYYY h:mm:ss A') : '-'}
					withTooltip={true}
				/>
				<Text className={userClasses} translationKey={data.archivedBy || '-'} withTooltip={true} />
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickRestore={hasRestoreAccess ? handleSetIdForRestoring : undefined}
						onClickDelete={hasDeleteAccess ? handleSetIdForDeletion : undefined}
						URLWithIDToEdit={`/clients/restaurants/edit?restaurantID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};
